<script setup lang="ts">
  import { onMounted, onUnmounted, ref, type Ref, watch } from 'vue'
  import Calendar from '@/components/ui/calendar/Calendar.vue'
  import { CalendarDate, type DateValue, getLocalTimeZone, today } from '@internationalized/date'
  import { useFormField } from '@/composables/useFormField'

  const emit = defineEmits(['change', 'update:modelValue'])
  const props = defineProps({
    field: {
      type: Object,
      default: () => ({})
    },
    modelValue: {
      type: String,
      default: ''
    }
  })

  useFormField({
    field: props.field,
    modelValue: props.modelValue.split(',') // Assuming useFormField expects an array
  })

  const selectedValue = ref(today(getLocalTimeZone())) as Ref<DateValue>

  watch(selectedValue, (newValue) => {
    if (newValue) {
      emitChanges(newValue)
    }
  })

  function parseDate(dateString: string): DateValue {
    const parsedDate = new Date(dateString)
    if (isNaN(parsedDate.getTime())) {
      return today(getLocalTimeZone())
    }
    const nc = new CalendarDate(
      parsedDate.getFullYear(),
      parsedDate.getMonth() + 1,
      parsedDate.getDate()
    )
    return nc
  }

  function emitChanges(newValue: DateValue) {
    const formattedDate = `${newValue.day}.${newValue.month}.${newValue.year}`
    if (formattedDate !== props.modelValue) {
      emit('update:modelValue', formattedDate)
      emit('change', formattedDate)
    }
  }

  onMounted(() => {
    if (props.modelValue) {
      let dateValues = props.modelValue.split(',')
      selectedValue.value =
        dateValues.length > 0 ? parseDate(dateValues[0]) : today(getLocalTimeZone())

      console.log('selectedValue', selectedValue.value)
    }
  })
</script>

<template>
  <Calendar
    v-model="selectedValue"
    class="rounded-md border"
    :input-field="true"
  />
</template>
